import React, { useEffect, useState } from "react";
import { myLocalStorage } from "../../../components/StorageHelper";
import axios from "axios";
import { NGROK } from "../../../APIs";
import useUserStore from "../../../services/userStore";
import CloudAnomalyAlertsTable from "../../../components/v2components/CloudSightAlerts/components/CloudAnomalyAlertsTable";

const AWSCloudAlerts = () => {
    const [selectedTenantName, setSelectedTenantName] = useState(null);
    const [tenantList, setTenantList] = useState([]);
    const [accountId, setAccountId] = useState(null);
    const [accountIdList, setAccountIdList] = useState([]);
    const userData = useUserStore((state) => state.user);

    const latestAccountId = myLocalStorage.getItem("selectedAwsAccount");
    const latestTenant = myLocalStorage.getItem("latestTenant")?.tenantName;

    const handleAccount = (value) => {
        const acc = accountIdList.find((p) => p === value);
        if (acc !== undefined) {
            setAccountId(acc);
            myLocalStorage.setItem("selectedAwsAccount", acc);
        }
    };

    const handleTenantChange = (value) => {
        const tenant = tenantList.find((t) => t.tenantName === value);
        if (tenant !== undefined) {
            setSelectedTenantName(tenant.tenantName);
            myLocalStorage.setItem("latestTenant", tenant);
        }
    };

    const fetchAccountIdList = async () => {
        if (!latestTenant) {
            setAccountIdList([]);
            return;
        }

        try {
            const response = await axios.get(`${NGROK}/api/aws/getAllAccounts`, {
                params: {
                    tenantName: latestTenant,
                },
            });

            const raw = response.data || [];
            const ids = raw.map((item) =>
                typeof item === "string" ? item : item.accountId
            );
            setAccountIdList(ids);
        } catch (error) {
            console.error("Failed to fetch accounts:", error);
        }
    };

    useEffect(() => {
        fetchAccountIdList();
        const interval = setInterval(() => {
            fetchAccountIdList();
        }, 10000);
        return () => clearInterval(interval);
    }, [latestTenant, latestAccountId]);

    useEffect(() => {
        if (tenantList.length === 1) {
            setSelectedTenantName(tenantList[0].tenantName);
            return;
        }

        if (tenantList.length > 1) {
            const storedTenantName = myLocalStorage.getItem("latestTenant")?.tenantName;
            const tenant =
                tenantList.find((t) => t.tenantName === storedTenantName) ||
                tenantList[0];
            setSelectedTenantName(tenant.tenantName);
        }
    }, [tenantList]);

    useEffect(() => {
        if (accountIdList.length === 1) {
            myLocalStorage.setItem("selectedAwsAccount", accountIdList[0]);
            setAccountId(accountIdList[0]);
            return;
        }

        if (accountIdList.length > 1) {
            const storedAccountId = myLocalStorage.getItem("selectedAwsAccount");
            const acc = accountIdList.find((p) => p === storedAccountId);

            if (acc) {
                setAccountId(acc);
            } else {
                myLocalStorage.setItem("selectedAwsAccount", accountIdList[0]);
                setAccountId(accountIdList[0]);
            }
        }
    }, [accountIdList]);

    useEffect(() => {
        const fetchTenants = async () => {
            try {
                const response = await axios.get(`${NGROK}/api/get-all-domains`);
                setTenantList(response.data || []);
            } catch (error) {
                console.error("Failed to fetch tenants:", error);
            }
        };

        fetchTenants();
    }, [userData]);

    return (
        <CloudAnomalyAlertsTable
            cloud="AWS"
            cloudId={accountId}
            tenantName={selectedTenantName}
            tenantList={tenantList}
            cloudIdList={accountIdList}
            onTenantChange={handleTenantChange}
            onCloudIdChange={handleAccount}
        />
    );
};

export default AWSCloudAlerts;